var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("canvas", {
      ref: "avatarEditorCanvas",
      staticClass: "cursorPointer",
      attrs: {
        width: _vm.canvasWidth,
        height: _vm.canvasHeight,
        id: "avatarEditorCanvas"
      },
      on: {
        dragover: function($event) {
          $event.preventDefault()
        },
        drop: _vm.onDrop,
        mousedown: _vm.onDragStart,
        touchstart: _vm.onDragStart,
        click: _vm.clicked
      }
    }),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticStyle: { display: "none" },
      attrs: { type: "file", accept: _vm.accept },
      on: { change: _vm.fileSelected }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19bf984a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19bf984a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-19bf984a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue
// module chunks = 0